import moment from "moment";
import {
  aggregateMealsByDay,
  decimalPlaces,
  getFinalKcalAndPercentage,
  roundMealPercentage,
  roundMealValue,
} from "../../../../helpers/mealsHelper";
import { getBaseDateFormat, UNIT } from "../../../../modules/constants";

export const getDataToDailyAveragesReport = (entries, allDates) => {
  const formattedEntries = aggregateMealsByDay(entries);
  const dailyAverages = getFinalKcalAndPercentage(formattedEntries);

  const finalData = [];

  const totalAverages = {
    completedDays: 0,
    sickDays: 0,
    mcf: 0,
    lcf: 0,
    protein: 0,
    carbs: 0,
    calories: 0,
  };

  dailyAverages.forEach((dailyEntry) => {
    const { date, completed, sickDay, fastingDay, meals } = dailyEntry;

    if (completed) {
      totalAverages.completedDays += 1;
      totalAverages.calories += dailyEntry.calories?.value || 0;
      totalAverages.mcf += dailyEntry.mediumChainFats?.percentage || 0;
      totalAverages.lcf += dailyEntry.longChainFats?.percentage || 0;
      totalAverages.protein += dailyEntry.protein?.percentage || 0;
      totalAverages.carbs += dailyEntry.carbohydrates?.percentage || 0;
    }

    if (sickDay) {
      totalAverages.sickDays += 1;
    }

    const dailyEntryAverages = {
      date: moment(date).format(getBaseDateFormat()),
      completed: completed ? "Yes" : "No",
      sickDay: sickDay ? "Yes" : "No",
      mcf: null,
      lcf: null,
      protein: null,
      carbs: null,
      calories: null,
    };

    if (fastingDay) {
      dailyEntryAverages.calories = "0.0";
      dailyEntryAverages.mcf = "0.0%";
      dailyEntryAverages.lcf = "0.0%";
      dailyEntryAverages.protein = "0.0%";
      dailyEntryAverages.carbs = "0.0%";
    } else if (!completed && meals.length > 0) {
      dailyEntryAverages.calories = "NC";
      dailyEntryAverages.mcf = "NC";
      dailyEntryAverages.lcf = "NC";
      dailyEntryAverages.protein = "NC";
      dailyEntryAverages.carbs = "NC";
    } else if (meals.length === 0) {
      dailyEntryAverages.calories = "N/A";
      dailyEntryAverages.mcf = "N/A";
      dailyEntryAverages.lcf = "N/A";
      dailyEntryAverages.protein = "N/A";
      dailyEntryAverages.carbs = "N/A";
    } else {
      dailyEntryAverages.calories = `${Number(
        roundMealValue(dailyEntry.calories?.value || 0)
      ).toFixed(decimalPlaces)}`;
      dailyEntryAverages.mcf = `${Number(
        roundMealPercentage(
          roundMealValue(dailyEntry.mediumChainFats?.percentage || 0)
        )
      ).toFixed(decimalPlaces)}${UNIT.PERCENTAGE}`;
      dailyEntryAverages.lcf = `${Number(
        roundMealPercentage(
          roundMealValue(dailyEntry.longChainFats?.percentage || 0)
        )
      ).toFixed(decimalPlaces)}${UNIT.PERCENTAGE}`;
      dailyEntryAverages.protein = `${Number(
        roundMealPercentage(roundMealValue(dailyEntry.protein?.percentage || 0))
      ).toFixed(decimalPlaces)}${UNIT.PERCENTAGE}`;
      dailyEntryAverages.carbs = `${Number(
        roundMealPercentage(
          roundMealValue(dailyEntry.carbohydrates?.percentage || 0)
        )
      ).toFixed(decimalPlaces)}${UNIT.PERCENTAGE}`;
    }

    finalData.push(dailyEntryAverages);
  });

  totalAverages.calories = `${Number(
    roundMealValue(
      totalAverages.completedDays > 0
        ? totalAverages.calories / totalAverages.completedDays
        : 0
    )
  ).toFixed(decimalPlaces)}`;

  totalAverages.mcf = `${Number(
    roundMealPercentage(
      roundMealValue(
        totalAverages.completedDays > 0
          ? totalAverages.mcf / totalAverages.completedDays
          : 0
      )
    )
  ).toFixed(decimalPlaces)}${UNIT.PERCENTAGE}`;
  totalAverages.lcf = `${Number(
    roundMealPercentage(
      roundMealValue(
        totalAverages.completedDays > 0
          ? totalAverages.lcf / totalAverages.completedDays
          : 0
      )
    )
  ).toFixed(decimalPlaces)}${UNIT.PERCENTAGE}`;
  totalAverages.protein = `${Number(
    roundMealPercentage(
      roundMealValue(
        totalAverages.completedDays > 0
          ? totalAverages.protein / totalAverages.completedDays
          : 0
      )
    )
  ).toFixed(decimalPlaces)}${UNIT.PERCENTAGE}`;
  totalAverages.carbs = `${Number(
    roundMealPercentage(
      roundMealValue(
        totalAverages.completedDays > 0
          ? totalAverages.carbs / totalAverages.completedDays
          : 0
      )
    )
  ).toFixed(decimalPlaces)}${UNIT.PERCENTAGE}`;

  const emptyData = [];
  allDates.forEach(function (date) {
    const emptyDayData = {
      date: moment(date).format(getBaseDateFormat()),
      completed: "No",
      sickDay: "No",
      mcf: "N/A",
      lcf: "N/A",
      protein: "N/A",
      carbs: "N/A",
      calories: "N/A",
    };
    emptyData.push(emptyDayData);
  });

  // After getting all the dates between startDate and endDate, fill each day with defaultData
  // and then replace each non empty day with respective meal data by date
  const dateRangeData = Object.values(
    [].concat(emptyData, finalData).reduce((r, c) => {
      r[c.date] = Object.assign(r[c.date] || {}, c);
      return r;
    }, {})
  );

  return { dateRangeData, totalsData: totalAverages };
};
